import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import {MessageService} from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { link } from 'src/types/link';
import { link_returndata } from 'src/types/link_returndata';
import { package_returndata } from 'src/types/package_returndata';
import { packagegroups_returndata } from 'src/types/packagegroup_returndata';
import { BusyService } from '../_services/busy.service';
import { GlobalService } from '../_services/global.service';
import { membership_returndata } from 'src/types/membership_returndata';
import { membership } from 'src/types/memberships';


@Component({
  selector: 'app-linkeditor',
  templateUrl: './linkeditor.component.html',
  styleUrls: ['./linkeditor.component.css']
})
export class LinkeditorComponent  implements OnInit {

  VenueID: string = localStorage.getItem("SmartVenueID")!;
  Link: link;
  httpResponse: any;
  id: string;
  pageReady: boolean = true;

  LinkNameValid: boolean = true;
  LinkPackageValid: boolean = true;
  LinkPackageGroupValid: boolean = true;
  LinkDateValid: boolean = true;
  LinkExpiryValid: boolean = true;
  LinkVoucherValid: boolean = true;
  LinkMembershipValid: boolean = true;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  pkgStateOptions: any[];
  stateOptions: any[];
  LinkType:string = "PACKAGE";
  LinkExpire: boolean = false;
  LinkDate: boolean = false;
  LinkTime: boolean = false;
  linkStartTimeHours: string;
  linkStartTimeMinutes: string;
  linkTimeHours: any[] = [];
  linkTimeMins: any[] = [];
  packages: any[];
  packagegroups: any[];
  selectedpackage: any;
  selectedpackagegroup: any;

  MinDate: Date = new Date();
  MaxDate: Date = new Date();

  DateToBook: Date = new Date();
  stateOptionsType: any[];
  memberships: membership[];
  selectedmembership: membership;

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private busyService: BusyService, private globalService: GlobalService) { 
    this.Link = {
      id: null,
      linkid:  null,
      linkname: "",
      venueid: this.VenueID,
      packageid: "",
      packagegroupid: "",
      membershipid: "",
      voucherid: "",
      datetobook: "1901-01-01",
      timetobook: "",
      admissionlist: "",
      expirydate: new Date(1,0,1, 0, 0, 0),
      disabled: false,
      events: false,
      linktype: "PACKAGE",
      vouchervalue: 0
    }
    this.pkgStateOptions = [{ label: 'Package', value: "PACKAGE" }, { label: 'Package Group', value: "PACKAGEGROUP" }];
    this.stateOptions = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
    this.stateOptionsType = [{ label: 'Package', value: "PACKAGE" }, { label: 'Package Group', value: "PACKAGEGROUP" }, { label: 'Event', value: "EVENTS" }, { label: 'Membership', value: "MEMBERSHIP" }];
      //, { label: 'Voucher', value: "VOUCHER" }, { label: 'Membership', value: "MEMBERSHIP" }];

    this.linkTimeHours = [
      {name: '00', code: '00'},
      {name: '01', code: '01'},
      {name: '02', code: '02'},
      {name: '03', code: '03'},
      {name: '04', code: '04'},
      {name: '05', code: '05'},
      {name: '06', code: '06'},
      {name: '07', code: '07'},
      {name: '08', code: '08'},
      {name: '09', code: '09'},
      {name: '10', code: '10'},
      {name: '11', code: '11'},
      {name: '12', code: '12'},
      {name: '13', code: '13'},
      {name: '14', code: '14'},
      {name: '15', code: '15'},
      {name: '16', code: '16'},
      {name: '17', code: '17'},
      {name: '18', code: '18'},
      {name: '19', code: '19'},
      {name: '20', code: '20'},
      {name: '21', code: '21'},
      {name: '22', code: '22'},
      {name: '23', code: '23'}
      ];
   
    this.linkTimeMins = [
        {name: '00', code: '00'},
        {name: '01', code: '01'},
        {name: '02', code: '02'},
        {name: '03', code: '03'},
        {name: '04', code: '04'},
        {name: '05', code: '05'},
        {name: '06', code: '06'},
        {name: '07', code: '07'},
        {name: '08', code: '08'},
        {name: '09', code: '09'},
        {name: '10', code: '10'},
        {name: '11', code: '11'},
        {name: '12', code: '12'},
        {name: '13', code: '13'},
        {name: '14', code: '14'},
        {name: '15', code: '15'},
        {name: '16', code: '16'},
        {name: '17', code: '17'},
        {name: '18', code: '18'},
        {name: '19', code: '19'},
        {name: '20', code: '20'},
        {name: '21', code: '21'},
        {name: '22', code: '22'},
        {name: '23', code: '23'},
        {name: '24', code: '24'},
        {name: '25', code: '25'},
        {name: '26', code: '26'},
        {name: '27', code: '27'},
        {name: '28', code: '28'},
        {name: '29', code: '29'},
        {name: '30', code: '30'},
        {name: '31', code: '31'},
        {name: '32', code: '32'},
        {name: '33', code: '33'},
        {name: '35', code: '34'},
        {name: '35', code: '35'},
        {name: '36', code: '36'},
        {name: '37', code: '37'},
        {name: '38', code: '38'},
        {name: '39', code: '39'},
        {name: '40', code: '40'},
        {name: '41', code: '41'},
        {name: '42', code: '42'},
        {name: '43', code: '43'},
        {name: '44', code: '44'},
        {name: '45', code: '45'},
        {name: '46', code: '46'},
        {name: '47', code: '47'},
        {name: '48', code: '48'},
        {name: '49', code: '49'},
        {name: '50', code: '50'},
        {name: '51', code: '51'},
        {name: '52', code: '52'},
        {name: '53', code: '53'},
        {name: '54', code: '54'},
        {name: '55', code: '55'},
        {name: '56', code: '56'},
        {name: '57', code: '57'},
        {name: '58', code: '58'},
        {name: '59', code: '59'},
      ];
  }

  doLinkExpiry()
  {
    if(this.LinkExpire)
    {
      this.Link.expirydate = new Date();
      this.Link.expirydate.setFullYear(new Date().getFullYear() + 1);

      
    }
    else
    {
      this.Link.expirydate = new Date(1,0,1, 0, 0, 0);
    }
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        this.busyService.busy();

        if(getAccess("CLASSES", user)){
          this.AccessAllowed = true;

          this.id = this.route.snapshot.paramMap.get('id');
          if(this.id != "0")
          {
            this.pageReady = false;
            this.http.get(bmxurl + "Link/" + this.VenueID + "/" + this.id).subscribe(response => {
              this.httpResponse = (response as link_returndata)
              if (this.httpResponse.succeeded)
              {
              
                this.Link = {
                  id: (this.httpResponse.data as link).id,
                  linkid: (this.httpResponse.data as link).linkid,
                  linkname: (this.httpResponse.data as link).linkname,
                  venueid: (this.httpResponse.data as link).venueid,
                  packageid: (this.httpResponse.data as link).packageid,
                  packagegroupid: (this.httpResponse.data as link).packagegroupid,
                  membershipid: (this.httpResponse.data as link).membershipid,
                  voucherid: (this.httpResponse.data as link).voucherid,
                  datetobook: (this.httpResponse.data as link).datetobook,
                  timetobook: (this.httpResponse.data as link).timetobook,
                  admissionlist: (this.httpResponse.data as link).admissionlist,
                  expirydate: new Date((this.httpResponse.data as link).expirydate),
                  disabled: (this.httpResponse.data as link).disabled,
                  events: (this.httpResponse.data as link).events,
                  linktype: (this.httpResponse.data as link).linktype,
                  vouchervalue: (this.httpResponse.data as link).vouchervalue
                };

                this.DateToBook = new Date(Number(this.Link.datetobook.substr(0, 4)), Number(this.Link.datetobook.substr(5, 2)) - 1, Number(this.Link.datetobook.substr(8, 2)));


                if(this.Link.packageid != "" && this.Link.linktype == null)
                {
                  this.Link.linktype = "PACKAGE";
                }
                else if(this.Link.packagegroupid != "" && this.Link.linktype == null)
                {
                  this.Link.linktype = "PACKAGEGROUP";
                }

                if(new Date(this.Link.datetobook).getFullYear() > 1901)
                {
                  this.LinkDate = true;
                }

                if(this.Link.timetobook != "")
                {
                  this.LinkTime = true;

                  this.linkStartTimeHours =  this.Link.timetobook.split(":")[0];
                  this.linkStartTimeMinutes = this.Link.timetobook.split(":")[1];
                }

                if(this.Link.expirydate.getFullYear() > 1901)
                {
                  this.LinkExpire = true;
                }

                this.http.get(bmxurl + "/packagelist/" + this.VenueID).subscribe(response => {
                  this.packages = (response as package_returndata).data

                  this.packages.forEach(element => {
                    if(element.packageId == this.Link.packageid)
                    {
                      this.selectedpackage = element;
                    }
                  });

                  this.http.get(bmxurl + "/packagegrouplist/" + this.VenueID).subscribe(response => {
                    this.packagegroups = (response as packagegroups_returndata).data

                    this.packagegroups = this.packagegroups.filter(x => x.packagegroupname  != "Other Packages");

                    this.packagegroups.forEach(element => {
                      if(element.packagegroupid == this.Link.packagegroupid)
                      {
                        this.selectedpackagegroup = element;
                      }
                    });

                      this.http.get(bmxurl + "/membershiptypelist/" + this.VenueID + "/false").subscribe(response => {
                        this.memberships = (response as membership_returndata).data

                        if (this.memberships != null)
                        {
                          this.memberships.forEach(element => {
                            if(element.membershiptypeid == this.Link.membershipid)
                            {
                              this.selectedmembership = element;
                            }
                          });
                        }

                        this.pageReady = true;
                        this.busyService.idle();

                      }, error => {
                      })

                  }, error => {
                  })


                }, error => {
                })
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting links'});
                this.pageReady = false;
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting links, error:' + error.messages[0]});
              this.pageReady = false;
            });
          }
          else
          {
            this.http.get(bmxurl + "/packagelist/" + this.VenueID).subscribe(response => {
              this.packages = (response as package_returndata).data

              this.packages.forEach(element => {
                if(element.packageId == this.Link.packageid)
                {
                  this.selectedpackage = element;
                }
              });

              this.http.get(bmxurl + "/packagegrouplist/" + this.VenueID).subscribe(response => {
                this.packagegroups = (response as packagegroups_returndata).data

                this.packagegroups = this.packagegroups.filter(x => x.packagegroupname != "Other Packages");

                this.http.get(bmxurl + "/membershiptypelist/" + this.VenueID + "/false").subscribe(response => {
                  this.memberships = (response as membership_returndata).data

                  if (this.memberships != null)
                  {
                    this.memberships.forEach(element => {
                      if(element.membershiptypeid == this.Link.membershipid)
                      {
                        this.selectedmembership = element;
                      }
                    });
                  }

                  this.pageReady = true;
                  this.busyService.idle();

                }, error => {
                })

              }, error => {
                })


            }, error => {
            })

          }
        }

        this.CompletedLoading = true;
      }
    }, error => {``
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  DoDateValidCheck()
  {
    if (new Date(this.DateToBook).getFullYear() <= 1901)
    {
      this.DateToBook = new Date();
    }
  }

  updateData()
  {
    if (this.DoValidCheck())
    {
      if(this.Link.events)
      {
        this.Link.packageid = "";
        this.Link.packagegroupid =  "";
        this.Link.datetobook = "1901-01-01";
        this.Link.timetobook =  "";
        this.Link.admissionlist = "";
      }

      if(this.Link.linktype == "PACKAGE" && this.Link.events == false)
      {
        this.Link.packageid = this.selectedpackage.packageId;
        this.Link.packagegroupid = "";
      }
      else if(this.Link.linktype == "PACKAGEGROUP" && this.Link.events == false)
      {
        this.Link.packageid = "";
        this.Link.packagegroupid = this.selectedpackagegroup.packagegroupid;

        this.Link.timetobook = "";
        this.LinkTime = false;
      }
      else if(this.Link.linktype == "MEMBERSHIP" && this.Link.events == false)
      {
        this.Link.packageid = "";
        this.Link.packagegroupid = "";
        this.Link.membershipid = this.selectedmembership.membershiptypeid;
      }

      if(this.LinkTime)
      {
        this.Link.timetobook = this.linkStartTimeHours + ":" + this.linkStartTimeMinutes;
      }
      else
      {
        this.Link.timetobook = "";
      }

      this.Link.datetobook = this.DateToBook.getFullYear() + "-" + ("0" + (this.DateToBook.getMonth() + 1)).slice(-2) + "-" + ("0" + this.DateToBook.getDate()).slice(-2);

      if(!this.LinkDate)
      {
        this.Link.datetobook = "1901-01-01"
      }

      if(this.id == "0")
      {
        this.http.post<link>(bmxurl + "/Link", this.Link).subscribe(response => {
          this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.messageService.add({severity:'success', summary:'Saved', detail:'Link successfully updated'});
              this.router.navigateByUrl("/linkmanager");
            }
            }, error => {
              this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
          })
      }
      else
      {
        this.Link.disabled = false;
        
        this.http.put<link>(bmxurl + "/Link", this.Link).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Link successfully updated'});
            this.router.navigateByUrl("/linkmanager");
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
        })
      }
    }
  }

  DoValidCheck()
  {

    this.Link.datetobook = this.DateToBook.getFullYear() + "-" + ("0" + (this.DateToBook.getMonth() + 1)).slice(-2) + "-" + ("0" + this.DateToBook.getDate()).slice(-2);
    let AllValid = true;

    if(this.Link.linkname == null || this.Link.linkname == "")
    {
      AllValid = false;
      this.LinkNameValid = false;
    }
    else
    {
      this.LinkNameValid = true;
    }

    if(this.selectedpackage == null && this.Link.linktype == "PACKAGE" && this.Link.events == false)
    {
      AllValid = false;
      this.LinkPackageValid = false;
    }
    else
    {
      this.LinkPackageValid = true;
    }

    if(this.selectedpackagegroup == null && this.Link.linktype == "PACKAGEGROUP" && this.Link.events == false)
    {
      AllValid = false;
      this.LinkPackageGroupValid = false;
    }
    else
    {
      this.LinkPackageGroupValid = true;
    }

    if(this.LinkDate && this.Link.linktype == "PACKAGE" && this.Link.events == false)
    {
      let PStartDate = new Date(new Date(this.selectedpackage.startDate).getFullYear(), new Date(this.selectedpackage.startDate).getMonth() + 1, new Date(this.selectedpackage.startDate).getDate());
      let PEndDate =   new Date(new Date(this.selectedpackage.endDate).getFullYear(), new Date(this.selectedpackage.endDate).getMonth() + 1, new Date(this.selectedpackage.endDate).getDate(), 23, 59, 59);
     
      let linkDate = new Date(new Date(this.Link.datetobook).getFullYear(), new Date(this.Link.datetobook).getMonth() + 1, new Date(this.Link.datetobook).getDate());

      this.MinDate = new Date(this.selectedpackage.startDate);
      this.MaxDate = new Date(this.selectedpackage.endDate);

      if (new Date(linkDate).getTime() < new Date(PStartDate).getTime() || new Date(linkDate).getTime() > new Date(PEndDate).getTime())
      {
        AllValid = false;
        this.LinkDateValid = false;
      }
      else
      {
        this.LinkDateValid = true;
      }
    }

    if(this.LinkExpire)
    {
      if(new Date(this.Link.expirydate) < new Date())
      {
        AllValid = false;
        this.LinkExpiryValid = false;
      }
      else
      {
        this.LinkExpiryValid = true;
      }
    }

    return AllValid;
  }

  returnToList()
  {
    this.router.navigateByUrl("/linkmanager");
  }
}
